// extracted by mini-css-extract-plugin
export default {"header":"Perfil_header__4m85K","panel":"Perfil_panel__DOXeo","panelSection":"Perfil_panelSection__iLIMA","subHeader":"Perfil_subHeader__6uU+5","userImg":"Perfil_userImg__jL1T7"};